import { Form } from "react-bootstrap";

import {
  Card,
  GridForm,
  GridFormItemWrapper,
  IconButton,
} from "@bagel-web/components";

import ParameterMapEditor from "./ParameterMapEditor";
import { FnDesc } from "../../types";

const FunctionEditor = ({
  index,
  fn,
  nameError,
  onChange,
  onDelete,
}: {
  // Identify functions by an index since function names are editable
  index: number;
  fn: FnDesc;
  // Why the name can't run as-is, or null; the step judges it against the
  // whole list.
  nameError: string | null;
  onChange: (next: FnDesc) => void;
  onDelete: () => void;
}) => (
  <Card>
    <div className="d-flex align-items-start gap-3">
      <div className="flex-grow-1">
        <GridForm $width="100%" $numCols={2}>
          <GridFormItemWrapper>
            <Form.Label htmlFor={`playground-function-name-${index}`}>
              Name
            </Form.Label>
            <Form.Control
              id={`playground-function-name-${index}`}
              className="font-monospace"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck={false}
              value={fn.name}
              isInvalid={nameError !== null}
              onChange={(event) =>
                onChange({ ...fn, name: event.target.value })
              }
              data-testid={`playground-function-name-${index}`}
            />
            {nameError !== null && (
              <Form.Control.Feedback type="invalid">
                {nameError}
              </Form.Control.Feedback>
            )}
          </GridFormItemWrapper>
          <GridFormItemWrapper colSpan={2}>
            <Form.Label htmlFor={`playground-function-docs-${index}`}>
              Description
            </Form.Label>
            <Form.Control
              id={`playground-function-docs-${index}`}
              as="textarea"
              rows={2}
              value={fn.docs}
              onChange={(event) =>
                onChange({ ...fn, docs: event.target.value })
              }
              data-testid={`playground-function-docs-${index}`}
            />
          </GridFormItemWrapper>
        </GridForm>
        <h6 className="mt-3">Arguments</h6>
        <ParameterMapEditor
          path={`playground-function-${index}-arg`}
          noun="argument"
          depth={0}
          map={{ parameters: fn.parameters, required: fn.required }}
          onChange={({ parameters, required }) =>
            onChange({ ...fn, parameters, required })
          }
        />
      </div>
      <IconButton
        className="bi-trash-fill"
        variant="secondary"
        tooltip="Delete this function."
        data-testid={`playground-function-delete-${index}`}
        onClick={onDelete}
      />
    </div>
  </Card>
);

export default FunctionEditor;
